import { FormHTMLAttributes } from 'react';

/**
 * This is used for web only, for accessibility reasons.
 */
export function Form({ ...props }: FormHTMLAttributes<HTMLFormElement>) {
  return (
    <form
      {...props}
      onSubmit={(evt) => {
        evt.preventDefault();
        props.onSubmit?.(evt);
      }}
    >
      <input type="submit" hidden />
      {props.children}
    </form>
  );
}
